"use client"
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

/**
 * The agreement sentence used across the auth flows, the way reputable
 * sign-up forms phrase it: "By continuing, you agree to our Terms of
 * Service and Privacy Policy." — with both documents as real links that
 * open the standalone public pages (/bedingungen, /datenschutz) in a new tab. Composed from
 * split i18n pieces so EN and DE word order both work. The recorded
 * consent policy version (ADR-012) is server-side only and never shown.
 */

import { useI18n } from "@/i18n"
import { LEGAL_PATHS } from "@/lib/legalRoutes"

const LINK_CLASS = "underline underline-offset-2 text-ink hover:text-green"

export function LegalAgreementText({
  prefixKey,
}: {
  prefixKey: "auth.agreeSignUpPrefix" | "auth.agreeSocialPrefix"
}) {
  const { t } = useI18n()
  // Plain anchors (not router Links): the pages open in a NEW TAB, so no SPA
  // navigation is involved — and the component stays renderable outside a
  // Router (the auth forms are unit-tested standalone).
  return (
    <>
      {t(prefixKey)}{" "}
      <a href={LEGAL_PATHS.terms} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
        {t("auth.termsLink")}
      </a>{" "}
      {t("auth.agreeConnector")}{" "}
      <a href={LEGAL_PATHS.privacy} target="_blank" rel="noopener noreferrer" className={LINK_CLASS}>
        {t("auth.privacyLink")}
      </a>
      {t("auth.agreeSuffix")}
    </>
  )
}
